export class Login {
  username: string;
  password: string;
  browser_details: object;
  timeZone: string;
  lang: string;
}

export class LoginResponse {
  success: boolean;
  message: string;
  // locale:string;   ------------- dont remove this comment
  user_data: {
    roles: {
      menu_tab: Array<{
        path: string;
      }>;
    };
    name: string;
    token: string;
    user_id: string;
    user_name: string;
    user_type: string;
    companyName: string;
    companyNameLogoUrl: string;
    appid: any;
    multiAppLogin: any;
    wabaAccounts?: any;
  };
}
